export default function getScrollbarsStyle() {
  if (!getScrollbarsStyle.style) {
    getScrollbarsStyle.style = [
      {
        selector: '*::-webkit-scrollbar',
        properties: {
          width: '10px!important',
          height: '10px',
          background: 'transparent!important',
        },
      },
      {
        selector: '*::-webkit-scrollbar-thumb',
        properties: {
          borderRadius: '5px!important',
          backgroundColor: 'rgba(156,158,140,0.3)!important',
          border: '1px rgba(0,0,0,0.7) solid!important',
          boxShadow: 'inset -1px -1px 5px 0px rgba(0, 0, 0, 0.5)!important',
          marginRight: '1px!important',
        },
      },
      {
        selector: '*::-webkit-scrollbar-track',
        properties: {
          display: 'none!important',
          opacity: '0!important',
          backgroundColor: 'transparent!important',
        },
      },
      {
        selector: '*::-webkit-scrollbar-corner',
        properties: {
          backgroundColor: 'transparent!important',
        },
      },
      {
        selector: '*::-webkit-scrollbar-track-piece',
        properties: {
          display: 'none!important',
          opacity: '0!important',
          backgroundColor: 'transparent!important',
        },
      },
      {
        selector: '*::-webkit-scrollbar-track-piece:start',
        properties: {
          display: 'none!important',
          opacity: '0!important',
          background: 'transparent!important',
        },
      },
      {
        selector: '*::-webkit-scrollbar-track-piece:end',
        properties: {
          display: 'none!important',
          opacity: '0!important',
          background: 'transparent!important',
        },
      },
      {
        selector: '*:hover::-webkit-scrollbar-thumb',
        properties: {
          backgroundColor: 'rgba(156,158,140,0.8)!important',
        },
      },
    ];
  }

  return getScrollbarsStyle.style;
}
